import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/app/[locale]/industries/industries-overview.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/node_modules/next/dist/client/link.js");
